import React from 'react'
import {getLocalStorageItem, objectLang, setPathBack} from "../functions"
import {MainPage} from "../pages/MainPage"

export class MainPageAdminClass extends React.Component {

    render() {

        const superUser = getLocalStorageItem('userData').superUser

        if (!superUser) {
            return (
                <MainPage />
            )
        }

        setPathBack(window.location.pathname)

        const l = objectLang().language.lang
        const navs = [
            {
                id: 1,
                to: `/${l}/admin/update-user`,
                name: 'Редактировать ЮЗЕРА',
                description: 'Получаем все данные из базы данных на определенного юзера',
                target: '',
            },
            {
                id: 2,
                to: `/${l}/admin/update-lang`,
                name: 'Обновить ПЕРЕВОД',
                description: 'Обновляем базу данных для перевода на поддерживаемые языки',
                target: '',
            },
            {
                id: 3,
                to: `/${l}/admin/check-collections`,
                name: 'Проверить DB',
                description: 'Проверяем нажодящиеся id в массивах папки на присутствие этих id в коллекциях БД.',
                target: '',
            },
            {
                id: 4,
                to: `/${l}/admin/profile`,
                name: 'Мой ПРОФИЛЬ',
                description: 'Профиль супер юзера т.е меня!',
                target: '_blank',
            },
        ];

        return React.createElement('div', null,

            React.createElement('main', {className: 'products navs-super-user container'},
                navs.map(nav =>
                    React.createElement('div', {key: nav.id, className: 'product-card admin-item container d-flex align-items-stretch'},
                        React.createElement('div', {className: 'admin-content d-flex flex-column justify-content-between flex-fill'},
                            React.createElement('h3', null, nav.name),
                            React.createElement('p', null, nav.description),
                            React.createElement('div', {className: 'mt-auto'},
                                React.createElement('button', null,
                                    React.createElement('a', {
                                        href: nav.to,
                                        className: 'd-block text-white text-decoration-none flex-fill',
                                        target: nav.target
                                    }, nav.name)
                                )
                            )
                        )
                    )
                )
            )
        )
    }
}
